import React from "react";
import { BrowserRouter } from "react-router-dom";

import "moment/locale/id";
import "./App.css";
import Components from "./components";

function App() {
  return (
    <BrowserRouter>
      <Components />
    </BrowserRouter>
  );
}

export default App;
